/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import { Grid, DialogContentText } from '@material-ui/core';
import * as Roles from '../../constants/role';
import * as actionsFolhaPontos from '../../store/folhaPonto/actions';
import * as selectorsFolhaPontos from '../../store/folhaPonto/reducer';
import * as selectorsAuth from '../../store/auth/reducer';
import { Input, DialogDefault, UsuarioSelect, DatePicker, OptionSelect, ArquivoContainer } from '../../components';
import moment from 'moment';
import clsx from 'clsx';

const schema = {
  usuarioId: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataInicio: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataFim: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  regimeTrabalhoId: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const useStyles = makeStyles(() => ({
  gridContainer: {
    marginTop: 0
  },
  fieldContainer: {
    paddingBottom: '0px !important'
  },
  cancelada: {
    color: "red",
    fontStyle: "italic"
  }
}));

const Formulario = ({ saveFolhaPonto, updateFolhaPonto, findFolhaPontoById, folhaPontoClearSelected, folhaPontoUpdateStatus, selectedFolhaPonto, 
  open, id, onClose, authData, uploadFilledFolhaPonto }) => {
  const classes = useStyles();

  const [values, setValues] = useState({});
  const [openCancelar, setOpenCancelar] = useState(false);

  const getDefaultValues = () => {
    return {
      criadoPorId: authData.id,
      criadoPorNome: authData.nome,
      dataCriacao: moment().valueOf(),
      dataInicio: moment().startOf('month').valueOf(),
      dataFim: moment().endOf('month').valueOf(),
      status: "CREATED",
      statusDescricao: 'Em Criação',
    }
  }

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open && !id) {
      setValues(getDefaultValues());
    }
  }, [id, open]);

  useEffect(() => {
    if (id) {
      findFolhaPontoById(id);
    }
  }, [id, findFolhaPontoById]);

  useEffect(() => {
    if (selectedFolhaPonto && selectedFolhaPonto.id) {
      setValues({
        ...selectedFolhaPonto,
        dataCriacao: moment(selectedFolhaPonto.dataCriacao).valueOf(),
      });
    }
  }, [selectedFolhaPonto]);

  const onSave = () => {
    const erros = validate(values, schema);
    setErrors(erros);
    if (!erros) {
      if (values.id) updateFolhaPonto(values.id, values);
      else saveFolhaPonto(values);
      onCloseLocal(true);
    }
  }

  const onCloseLocal = (isSave) => {
    folhaPontoClearSelected();
    setErrors({});
    setValues(getDefaultValues());
    onClose(isSave);
  }

  const isDisabled = () => values.cancelada || values.status !== "CREATED" || values.criadoPorId !== authData.id;

  return (
    <>
      <DialogDefault
        open={open}
        handlerCancel={() => onCloseLocal(false)}
        handlerConfirm={onSave}
        title="Folha de Ponto"
        confirmMessage="Salvar"
        cancelMessage="Fechar"
        contentClassName={classes.contentClassName}
        maxWidth="md"
        readOnly={isDisabled()}
      >
        <Grid container spacing={3} className={classes.gridContainer}>
          {values.cancelada && <Grid item xs={12} className={clsx(classes.fieldContainer, classes.cancelada)}>
            **** Folha de Ponto cancelada por {values.canceladaPorNome} em {values.dataCanceladaValue}
          </Grid>}
          <Grid item xs={12} className={classes.fieldContainer}>
            <UsuarioSelect
              label="Usuário(s)"
              onSelect={usuarioId => setValues({ ...values, usuarioId })}
              ativo
              grupos={[Roles.ADMIN, Roles.INSPETOR]}
              value={values.usuarioId}
              isRequired
              error={errors && errors.usuarioId}
              disabled={isDisabled()}
              multiSelect={!values.id}
            />
          </Grid>
          <Grid item xs={3} className={classes.fieldContainer}>
            <OptionSelect
              label="Regime de Trabalho"
              codigo="USUARIO_REGIME_TRABALHO"
              isRequired
              onSelect={regimeTrabalhoId => setValues({
                ...values,
                regimeTrabalhoId,
              })}
              value={values.regimeTrabalhoId}
              error={errors && errors.regimeTrabalhoId}
              disabled={isDisabled()}
            />
          </Grid>
          <Grid item xs={3} className={classes.fieldContainer}>
            <DatePicker
              label="Data Início"
              isRequired
              error={errors && errors.dataInicio}
              onChange={data => setValues({
                ...values,
                dataInicio: data.valueOf()
              })}
              value={values.dataInicio}
              disabled={isDisabled()}
            />
          </Grid>
          <Grid item xs={3} className={classes.fieldContainer}>
            <DatePicker
              label="Data Fim"
              isRequired
              error={errors && errors.dataFim}
              onChange={data => setValues({
                ...values,
                dataFim: data.valueOf()
              })}
              value={values.dataFim}
              disabled={isDisabled()}
            />
          </Grid>
          <Grid item xs={3} className={classes.fieldContainer}>
            <Input label="Status" value={values.statusDescricao} disabled />
          </Grid>
          <Grid item xs={3} className={classes.fieldContainer}>
            <Input label="Criado Por" value={values.criadoPorNome} disabled />
          </Grid>
          <Grid item xs={3} className={classes.fieldContainer}>
            <Input label="Data Criação" value={values.dataCriacao ? moment(Number(values.dataCriacao)).format("DD/MM/YYYY HH:mm") : moment().format("DD/MM/YYYY HH:mm")} disabled />
          </Grid>
          {values.error && <Grid item xs={12} className={classes.fieldContainer}>
            <Input
              disabled
              label="Error"
              name="error"
              value={values.error}
              rows={4}
              multiline
            />
          </Grid>}
          {values.id && <ArquivoContainer
            arquivos={values.arquivos}
            onSave={arquivos => {
              if (arquivos && arquivos.length > 0) {
                uploadFilledFolhaPonto(values.id, arquivos[0], updateData => {
                  let statusDescricao = "Recebida";
                  if (updateData.status === "ERROR") statusDescricao = "Error";
                  setValues({ ...values, status: updateData.status, filled: updateData.filled, statusDescricao, arquivos: [ ...values.arquivos, updateData.arquivo ] });
                });
              }
            }}
            headerTitle="Documentos"
            addTitle={"Enviar Folha Preenchida"}
            hasAdd={!values.filled || values.status === "NOT_VALID"}
            showDelete={false}
            filesLimit={1}
            shouldSaveSync
          />}
        </Grid>
      </DialogDefault>
      <DialogDefault
        open={openCancelar}
        useFullScreen={false}
        handlerCancel={() => setOpenCancelar(false)}
        handlerConfirm={() => { 
          setOpenCancelar(false); 
          folhaPontoUpdateStatus(values.id, "CANCEL"); 
        }}
        title="Confirmação"
        confirmMessage="Sim"
        cancelMessage="Não"
      >
        <DialogContentText> Deseja realmente cancelar a folha de ponto? </DialogContentText>
      </DialogDefault>
    </>
  );
};

const mapStateToProps = state => ({
  selectedFolhaPonto: selectorsFolhaPontos.getSelectedFolhaPonto(state),
  authData: selectorsAuth.getAuth(state),
  userRole: selectorsAuth.getRole(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsFolhaPontos,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
